import {log} from "@dp-instant/utils";
import {TypesSocial} from "@dp-instant/interfaces";
import {ISocial} from "@dp-instant/social";
import {inject, injectable} from "inversify";
import {Playdeck} from "../utils/Playdeck";

type Value = number | string | boolean;
type StoreType = {[key: string]: Value};

@injectable()
export abstract class CookieModelBase<T = string> {
    protected abstract getDefaultStore(): StoreType;

    private _store: StoreType = this.getDefaultStore();

    @inject(TypesSocial.model)
    protected readonly social: ISocial;

    constructor() {
        if (process.env.NODE_ENV === "development") {
            (window as any).v_cookie = this;
        }
    }

    async sync(): Promise<void> {
        const cookie = this.social.cookie;
        let cookieData: StoreType;
        try {
            cookieData = JSON.parse((await Playdeck.getData("save")) ?? `{}`);
        } catch (e) {
            console.warn("[Cookie] JSON.parse failed, resetting to defaults:", e);
            cookieData = {};
        }

        Object.keys(cookieData).forEach((k: string) => {
            if (typeof cookieData[k] === "undefined") {
                const storeValue = this._store[k];
                log.debug(k, "set to default", storeValue);
                cookie.save(k, storeValue);
            } else {
                this._store[k] = cookieData[k];
            }
        });
    }

    protected get(key: string): Value {
        return this._store[key];
    }
    protected set(key: string, value: Value) {
        this._store[key] = value;

        Playdeck.setData("save", JSON.stringify(this._store));
        this.social.cookie.save(key, value);
    }

    public clear() {
        this._store = this.getDefaultStore();
        Object.keys(this._store).forEach((k: string) => {
            const storeValue = this._store[k];
            log.debug(k, "set to default", storeValue);
            this.social.cookie.save(k, storeValue);
        });
    }
}
